import { FaqDto, FaqDtoImpl, FaqDataListDto, FaqDataDto } from './faqdto';
import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';

export class FaqBuilder
{
    constructor(private faqList: any)
    {
        if(faqList.faqList === undefined)
        {
            throw new NoDataException("FAQ data doesnt exists");
        }
    }

    buildAll(): FaqDto[]
    {
        return this.parseFaqDetailsResponse();
    }
    
    private parseFaqDetailsResponse(): FaqDto[]
    {
        let listOfFaq: FaqDto[] = [];
        
        let faqDto = null;
       
        this.faqList.faqList.forEach((faqItem: any) =>
        {
            faqDto = new FaqDtoImpl();
            faqDto.setFaqQuestion(faqItem.question);
            console.log("parseFaqDetailsResponse()",JSON.stringify(faqItem.question));
            // faqDto.setFaqAnswer(faqItem.answer[0].list);
            faqDto.setFaqAnswerHeader(faqItem.answer[0].header);
            
            let faqDataList: FaqDataListDto[] = [];
            let faqDataListDto = null;
            faqItem.answer[0].dataList.forEach((datalist: any) =>
            {
                faqDataListDto = new FaqDataListDto();

                let faqDataDto = null;
                let faqListDto: FaqDataDto[] = [];
                datalist.data.forEach((data: any) =>
                {
                    faqDataDto = new FaqDataDto();

                    faqDataDto.setText(data.text);
                    faqDataDto.setStyle(new Object(data.style));

                    faqListDto.push(faqDataDto);
                });

                faqDataListDto.setData(faqListDto);
                faqDataList.push(faqDataListDto);
            });

            faqDto.setFaqDataList(faqDataList);
            listOfFaq.push(faqDto);
        });
        return listOfFaq;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/faq/faqbuilder.ts